// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1U4d4","buttons":"RemoveExpirationActionButtons_buttons__1CWv1"};